const ACTION_CODES = {
  DEFAULT_ACTION: 'DEFAULT_ACTION',
  BACK_TO_BOOKING_MAGNET: 'BACK_TO_BOOKING_MAGNET',
  BACK_TO_SEARCH_RESULTS: 'BACK_TO_SEARCH_RESULTS',
  REDIRECT_TO_CUSTOM_PAGE: 'REDIRECT_TO_CUSTOM_PAGE',
  REDIRECT_TO_LOGIN_PAGE: 'REDIRECT_TO_LOGIN_PAGE',
  TRANSACTION_PENDING: 'TRANSACTION_PENDING',
  CUSTOMER_PRESENT_CARD_PAYMENT_ERROR: 'CUSTOMER_PRESENT_CARD_PAYMENT_ERROR',
  UPDATE_PASSENGERS_ETAP_ERROR: 'UPDATE_PASSENGERS_ETAP_ERROR',
  REDIRECT_TO_CLUB_EUROSTAR: 'REDIRECT_TO_CLUB_EUROSTAR'
};

const ERROR_CODES = {
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  S3_AUTHORISATION_ERROR: 'S3_AUTHORISATION_ERROR'
};

export { ACTION_CODES, ERROR_CODES };
